import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { HttpModule, Http, RequestOptions } from '@angular/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DashboardComponent } from './dashboard.component';
import { AuthGuardComponent } from '../service/auth.guard.component';
import { HttpserviceService } from '../service/http.service.service';
import { GlobalConfig } from '../entities/global-config';
import { UtilsService } from '../service/utils.service';
import { AuthService } from '../service/auth.service';
import { TokenService } from '../service/token.service';
import { HttpService } from '../service/http.service';
import { ChartsModule } from 'ng2-charts';
import { Daterangepicker } from 'ng2-daterangepicker';
import { DaterangepickerConfig } from 'ng2-daterangepicker';
import { AgentsComponent } from '../agentManagement/agents/agents.component';
import { SetAgentComponent } from '../agentManagement/set-agent/set-agent.component';
import { UpdateAgentPasswordComponent } from '../agentManagement/update-agent-password/update-agent-password.component';
import { BsDatepickerModule } from 'ngx-bootstrap';
import { ViewComponent } from '../agentManagement/view/view.component';
import { AreaComponent } from '../areasManagement/areas/area/area.component';
import { SubAreaComponent } from '../areasManagement/subArea/sub-area/sub-area.component';
import { SubSubAreaComponent } from '../areasManagement/subSubArea/sub-area/sub-area.component';
import { CitiesComponent } from '../areasManagement/city/cities/cities.component';
import { DistrictsComponent } from '../areasManagement/district/districts/districts.component';
import { StatesComponent } from '../areasManagement/state/states/states.component';
import { CountriesComponent } from '../areasManagement/country/countries/countries.component';
import { SetAreaComponent } from '../areasManagement/areas/set-area/set-area.component';
import { SetCityComponent } from '../areasManagement/city/set-city/set-city.component';
import { SetSubareaComponent } from '../areasManagement/subArea/set-subarea/set-subarea.component';
import { SetSubSubareaComponent } from '../areasManagement/subSubArea/set-subarea/set-subarea.component';
import { SetDistrictComponent } from '../areasManagement/district/set-district/set-district.component';
import { SetStateComponent } from '../areasManagement/state/set-state/set-state.component';
import { SetCountryComponent } from '../areasManagement/country/set-country/set-country.component';
import { CategoriesComponent } from '../propertiesManagement/category/categories/categories.component';
import { FacilitiesComponent } from '../propertiesManagement/facility/facilities/facilities.component';
import { FurnishesComponent } from '../propertiesManagement/furnish/furnishes/furnishes.component';
import { PropertiesComponent } from '../propertiesManagement/property/properties/properties.component';
import { ProjectsComponent } from '../projectsManagement/project/projects/projects.component';
import { DevelopersComponent } from '../projectsManagement/developer/developers/developers.component';
import { RentalsComponent } from '../propertiesManagement/rental/rentals/rentals.component';
import { SetCategoryComponent } from '../propertiesManagement/category/set-category/set-category.component';
import { SetFurnishComponent } from '../propertiesManagement/furnish/set-furnish/set-furnish.component';
import { SetRentalComponent } from '../propertiesManagement/rental/set-rental/set-rental.component'
import { SetFacilityComponent } from '../propertiesManagement/facility/set-facility/set-facility.component';
import { SetPropertyComponent } from '../propertiesManagement/property/set-property/set-property.component';
import { SetProjectComponent } from '../projectsManagement/project/set-project/set-project.component';
import { EmailLeadsComponent } from '../manageLead/email-leads/email-leads.component';
import { EmailProjectLeadsComponent } from '../manageProjectLead/email-leads/email-leads.component';
import { PhoneClicksComponent } from '../manageLead/phone-clicks/phone-clicks.component';
import { WhatsappLeadsComponent } from '../manageLead/whatsapp-leads/whatsapp-leads.component';
import { PhoneProjectClicksComponent } from '../manageProjectLead/phone-clicks/phone-clicks.component';
import { WhatsappProjectLeadsComponent } from '../manageProjectLead/whatsapp-leads/whatsapp-leads.component';
import { PackagesComponent } from '../Package/packages/packages.component';
import { SetPackageComponent } from '../Package/set-package/set-package.component';
import { SubscriberComponent } from '../Subscriber/subscriber/subscriber.component';
import { UpdateSubscriberComponent } from '../Subscriber/update-subscriber/update-subscriber.component';
import { RolesComponent } from '../roles/roles/roles.component';
import { SetRoleComponent } from '../roles/set-role/set-role.component';
import { WelcomeComponent } from '../welcome/welcome.component';
import { MainDashboardComponent } from '../mainDashboard/main-dashboard/main-dashboard.component';
import { MainProjectDashboardComponent } from '../mainProjectDashboard/main-dashboard/main-dashboard.component';
import { PermissionsComponent } from '../permission/permissions/permissions.component';
import { SetPermissionComponent } from '../permission/set-permission/set-permission.component';
import { RouteComponent } from '../routes/route/route.component';
import { SetRouteComponent } from '../routes/set-route/set-route.component';
import { UserProfileComponent } from '../userProfile/user-profile/user-profile.component';
import { UnAuthorizedComponent } from '../auth/un-authorized/un-authorized.component';
import { UsersComponent } from '../users/users/users.component';
import { SetUserComponent } from '../users/set-user/set-user.component';
import { BlacklistComponent } from '../blacklist/blacklist/blacklist.component';
import { SetBlacklistComponent } from '../blacklist/set-blacklist/set-blacklist.component';

import { VisitorsComponent } from '../visitors/visitors/visitors.component';

import { RemoveSpacePipe } from '../service/filter.pipe';
import { ConformMessageComponent } from '../conform-message/conform-message/conform-message.component';
import { CronjobComponent } from '../cronjob/cronjob/cronjob.component';
import { SetCronjobComponent } from '../cronjob/set-cronjob/set-cronjob.component';
import { RunXmlComponent } from '../cronjob/run-xml/run-xml.component';

import { CronjobGmkComponent } from '../cronjob/cronjob-gmk/cronjob-gmk.component';
import { SetcronjobGmkComponent } from '../cronjob/Setcronjob-gmk/Setcronjob-gmk.component';
import { RunxmlGmkComponent } from '../cronjob/runxml-gmk/runxml-gmk.component';

import { LogsComponent } from '../logs/logs.component';
import { RentalInquiryComponent } from '../rentalInquiry/rental-inquiry/rental-inquiry.component';
import { UpdateRentaiInquiryComponent } from '../rentalInquiry/update-rentai-inquiry/update-rentai-inquiry.component';

import {PaginationModule, TabsModule, TypeaheadModule, ModalModule, PopoverModule, BsModalRef, BsModalService, TooltipModule} from 'ngx-bootstrap';
import { SetDeveloperComponent } from '../projectsManagement/developer/set-developer/set-developer.component';


const routes: Routes = [{
  path: '', component: DashboardComponent,canActivate: [AuthGuardComponent],
  children: [

    // welcome
    { path: '', component: WelcomeComponent, canActivate: [AuthGuardComponent] },
    { path: 'welcome', component: WelcomeComponent, canActivate: [AuthGuardComponent]},

    // agents
    { path: 'agents', component: AgentsComponent, canActivate: [AuthGuardComponent]},
    { path: 'saveAgent', component: SetAgentComponent, canActivate: [AuthGuardComponent]},
    { path: 'saveAgent/:id', component: SetAgentComponent, canActivate: [AuthGuardComponent] },
    { path: 'updateAgentPassword/:id', component: UpdateAgentPasswordComponent, canActivate: [AuthGuardComponent] },
    // areas
    { path: 'areas', component: AreaComponent, canActivate: [AuthGuardComponent]},
    { path: 'saveAreas', component: SetAreaComponent, canActivate: [AuthGuardComponent]},
    { path: 'saveAreas/:id', component: SetAreaComponent, canActivate: [AuthGuardComponent] },
    // cities
    { path: 'cities', component: CitiesComponent, canActivate: [AuthGuardComponent]},
    { path: 'saveCities', component: SetCityComponent, canActivate: [AuthGuardComponent]},
    { path: 'saveCities/:id', component: SetCityComponent, canActivate: [AuthGuardComponent] },
    // subarea
    { path: 'subarea', component: SubAreaComponent, canActivate: [AuthGuardComponent]},
    { path: 'saveSubAreas', component: SetSubareaComponent, canActivate: [AuthGuardComponent]},
    { path: 'saveSubAreas/:id', component: SetSubareaComponent, canActivate: [AuthGuardComponent] },
    // subsubarea
    { path: 'subsubarea', component: SubSubAreaComponent, canActivate: [AuthGuardComponent] },
    { path: 'saveSubSubAreas', component: SetSubSubareaComponent, canActivate: [AuthGuardComponent] },
    { path: 'saveSubSubAreas/:id', component: SetSubSubareaComponent, canActivate: [AuthGuardComponent] },
    // districts
    { path: 'districts', component: DistrictsComponent, canActivate: [AuthGuardComponent]},
    { path: 'saveDistricts', component: SetDistrictComponent, canActivate: [AuthGuardComponent] },
    { path: 'saveDistricts/:id', component: SetDistrictComponent, canActivate: [AuthGuardComponent] },
    // states
    { path: 'states', component: StatesComponent, canActivate: [AuthGuardComponent] },
    { path: 'saveState', component: SetStateComponent, canActivate: [AuthGuardComponent]},
    { path: 'saveState/:id', component: SetStateComponent, canActivate: [AuthGuardComponent] },
    // countries
    { path: 'countries', component: CountriesComponent, canActivate: [AuthGuardComponent]},
    { path: 'saveCountries', component: SetCountryComponent, canActivate: [AuthGuardComponent]},
    { path: 'saveCountries/:id', component: SetCountryComponent, canActivate: [AuthGuardComponent] },
    // categories
    { path: 'categories', component: CategoriesComponent, canActivate: [AuthGuardComponent] },
    { path: 'saveCategory', component: SetCategoryComponent, canActivate: [AuthGuardComponent]},
    { path: 'saveCategory/:id', component: SetCategoryComponent, canActivate: [AuthGuardComponent]},
    // facility
    { path: 'facility', component: FacilitiesComponent, canActivate: [AuthGuardComponent]},
    { path: 'savefacility', component: SetFacilityComponent, canActivate: [AuthGuardComponent]},
    { path: 'savefacility/:id', component: SetFacilityComponent, canActivate: [AuthGuardComponent]},
    // furnish
    { path: 'furnish', component: FurnishesComponent, canActivate: [AuthGuardComponent]},
    { path: 'savefurnish', component: SetFurnishComponent, canActivate: [AuthGuardComponent]},
    { path: 'savefurnish/:id', component: SetFurnishComponent, canActivate: [AuthGuardComponent] },

    // rental
    { path: 'rental', component: RentalsComponent, canActivate: [AuthGuardComponent]},
    { path: 'saveRental', component: SetRentalComponent, canActivate: [AuthGuardComponent]},
    { path: 'saveRental/:id', component: SetRentalComponent, canActivate: [AuthGuardComponent] },


    { path: 'property', component: PropertiesComponent, canActivate: [AuthGuardComponent] },
    { path: 'updateProperty', component: SetPropertyComponent, canActivate: [AuthGuardComponent] },
    { path: 'updateProperty/:id', component: SetPropertyComponent, canActivate: [AuthGuardComponent] },

    // Project
    { path: 'project', component: ProjectsComponent, canActivate: [AuthGuardComponent] },
    { path: 'updateProject', component: SetProjectComponent, canActivate: [AuthGuardComponent] },
    { path: 'updateProject/:id', component: SetProjectComponent, canActivate: [AuthGuardComponent] },

    // Developers
    { path: 'developers', component: DevelopersComponent, canActivate: [AuthGuardComponent] },
    { path: 'saveDeveloper', component: SetDeveloperComponent, canActivate: [AuthGuardComponent] },
    { path: 'saveDeveloper/:id', component: SetDeveloperComponent, canActivate: [AuthGuardComponent] },

    // leads
    { path: 'emailLeads', component: EmailLeadsComponent, canActivate: [AuthGuardComponent]},
    { path: 'phoneClicks', component: PhoneClicksComponent, canActivate: [AuthGuardComponent]},
    { path: 'whatsapp', component: WhatsappLeadsComponent, canActivate: [AuthGuardComponent]},

    // Project Leads
    { path: 'emailProjectLeads', component: EmailProjectLeadsComponent, canActivate: [AuthGuardComponent] },
    { path: 'phoneProjectClicks', component: PhoneProjectClicksComponent, canActivate: [AuthGuardComponent] },
    { path: 'whatsappProject', component: WhatsappProjectLeadsComponent, canActivate: [AuthGuardComponent] },
    //
    // packages
    { path: 'packages', component: PackagesComponent, canActivate: [AuthGuardComponent] },
    { path: 'savePackages', component: SetPackageComponent, canActivate: [AuthGuardComponent]},
    { path: 'savePackages/:id', component: SetPackageComponent, canActivate: [AuthGuardComponent]},

    // subscriber
    { path: 'subscriber', component: SubscriberComponent, canActivate: [AuthGuardComponent]},
    { path: 'updateSubscriber', component: UpdateSubscriberComponent, canActivate: [AuthGuardComponent]},
    { path: 'updateSubscriber/:id', component: UpdateSubscriberComponent, canActivate: [AuthGuardComponent]},

    // role
    { path: 'role', component: RolesComponent, canActivate: [AuthGuardComponent] },
    { path: 'setrole', component: SetRoleComponent, canActivate: [AuthGuardComponent] },
    { path: 'setrole/:id', component: SetRoleComponent, canActivate: [AuthGuardComponent] },

    // mainPropertyDashboard
    { path: 'dashboard', component: MainDashboardComponent, canActivate: [AuthGuardComponent]},

    // mainProjectDashboard
    { path: 'projectDashboard', component: MainProjectDashboardComponent, canActivate: [AuthGuardComponent] },

    // permission
    { path: 'permission', component: PermissionsComponent, canActivate: [AuthGuardComponent] },
    { path: 'setpermission', component: SetPermissionComponent, canActivate: [AuthGuardComponent] },
    { path: 'setpermission/:id', component: SetPermissionComponent, canActivate: [AuthGuardComponent] },

    // route
    { path: 'route', component: RouteComponent, canActivate: [AuthGuardComponent] },
    { path: 'saveRoute', component: SetRouteComponent, canActivate: [AuthGuardComponent] },
    { path: 'saveRoute/:id', component: SetRouteComponent, canActivate: [AuthGuardComponent] },

    // userprofile
    { path: 'userprofile', component: UserProfileComponent, canActivate: [AuthGuardComponent] },

    { path: 'un-authorized', component: UnAuthorizedComponent, canActivate: [AuthGuardComponent]},

    // users
    { path: 'users', component: UsersComponent, canActivate: [AuthGuardComponent] },
    { path: 'setuser', component: SetUserComponent, canActivate: [AuthGuardComponent] },
    { path: 'setuser/:id', component: SetUserComponent, canActivate: [AuthGuardComponent] },

    // blacklist
    { path: 'blacklist', component: BlacklistComponent, canActivate: [AuthGuardComponent] },
    { path: 'saveblacklist', component: SetBlacklistComponent, canActivate: [AuthGuardComponent] },

    // visitors
    { path: 'visitors', component: VisitorsComponent, canActivate: [AuthGuardComponent] },
    //cronjob

    { path: 'cronjob', component: CronjobComponent, canActivate: [AuthGuardComponent] },
    { path: 'setcronjob', component: SetCronjobComponent, canActivate: [AuthGuardComponent] },
    { path: 'runxml', component: RunXmlComponent, canActivate: [AuthGuardComponent] },
    { path: 'setcronjob/:id', component: SetCronjobComponent, canActivate: [AuthGuardComponent] },

    //cronjobGmk

    { path: 'cronjobGmk', component: CronjobGmkComponent, canActivate: [AuthGuardComponent] },
    { path: 'setcronjobGmk', component: SetcronjobGmkComponent, canActivate: [AuthGuardComponent] },
    { path: 'runGmk', component: RunxmlGmkComponent, canActivate: [AuthGuardComponent] },
    { path: 'setcronjobGmk/:id', component: SetcronjobGmkComponent, canActivate: [AuthGuardComponent] },

     //logs

    { path: 'logs', component: LogsComponent, canActivate: [AuthGuardComponent] },
    { path: 'logs/:id', component: LogsComponent, canActivate: [AuthGuardComponent] },

    //InquiryComponent
    { path: 'inquiries', component: RentalInquiryComponent, canActivate: [AuthGuardComponent] },
    { path: 'updateinquires', component: UpdateRentaiInquiryComponent, canActivate: [AuthGuardComponent] },
    { path: 'updateinquires/:id', component: UpdateRentaiInquiryComponent, canActivate: [AuthGuardComponent] },
  ]
}];

@NgModule({
  declarations: [
    DashboardComponent,
    AgentsComponent,
    SetAgentComponent,
    UpdateAgentPasswordComponent,
    ViewComponent,
    AreaComponent,
    SubAreaComponent,
    SubSubAreaComponent,
    CitiesComponent,
    DistrictsComponent,
    StatesComponent,
    CountriesComponent,
    SetAreaComponent,
    SetCityComponent,
    SetSubareaComponent,
    SetSubSubareaComponent,
    SetDistrictComponent,
    SetStateComponent,
    SetCountryComponent,
    CategoriesComponent,
    FacilitiesComponent,
    FurnishesComponent,
    RentalsComponent,
    PropertiesComponent,
    ProjectsComponent,
    DevelopersComponent,
    SetDeveloperComponent,
    SetCategoryComponent,
    SetFurnishComponent,
    SetRentalComponent,
    SetFacilityComponent,
    SetPropertyComponent,
    SetProjectComponent,
    EmailLeadsComponent,
    EmailProjectLeadsComponent,
    PhoneClicksComponent,
    WhatsappLeadsComponent,
    PhoneProjectClicksComponent,
    WhatsappProjectLeadsComponent,
    PackagesComponent,
    SetPackageComponent,
    SubscriberComponent,
    UpdateSubscriberComponent,
    RolesComponent,
    SetRoleComponent,
    WelcomeComponent,
    MainDashboardComponent,
    MainProjectDashboardComponent,
    PermissionsComponent,
    SetPermissionComponent,
    RouteComponent,
    SetRouteComponent,
    UserProfileComponent,
    UnAuthorizedComponent,
    UsersComponent,
    SetUserComponent,
    BlacklistComponent,
    SetBlacklistComponent,
    VisitorsComponent,
    RemoveSpacePipe,
    ConformMessageComponent,
    CronjobComponent,
    SetCronjobComponent,
    RunXmlComponent,
    LogsComponent,
    RentalInquiryComponent,
    UpdateRentaiInquiryComponent,
    CronjobGmkComponent,
    SetcronjobGmkComponent,
    RunxmlGmkComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    ReactiveFormsModule,
    FormsModule,
    HttpModule,
    PaginationModule.forRoot(),
    TabsModule.forRoot(),
    TypeaheadModule.forRoot(),
    ModalModule.forRoot(),
    [BsDatepickerModule.forRoot()],
    ChartsModule,
    Daterangepicker,
    TooltipModule.forRoot(),
  ],
  providers: [
    HttpModule,
    AuthGuardComponent,
    HttpserviceService,
    GlobalConfig,
    UtilsService,
    AuthService,
    HttpService,
    TokenService,
    BsModalRef,
    ViewComponent,
    ConformMessageComponent,
  ],
  entryComponents: [
    ViewComponent,
    ConformMessageComponent
  ],
})
export class DashboardModule { }



// WEBPACK FOOTER //
// D:/Projects/Web/Dubai/DubaisaleV1/cpapi.v1/CPDubaisaleApp/src/app/dashboard/dashboard.module.ts